import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './HistoryPage.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// 店舗名 · 氏名 の形で投稿者を組み立てる。
// 記録前の過去分は両方とも空なので「投稿者不明」を返す。
function formatAuthor(item) {
  const parts = [item.shop_name, item.user_name].filter(Boolean);
  return parts.length > 0 ? parts.join(' · ') : '投稿者不明';
}

function HistoryPage() {
  const navigate = useNavigate();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadHistory();
  }, []);

  const loadHistory = async () => {
    try {
      const response = await axios.get(`${API_URL}/history`);
      setHistory(response.data.history || []);
    } catch (error) {
      console.error('履歴の読み込みエラー:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (historyId) => {
    if (!window.confirm('この会話履歴を削除しますか？')) return;

    try {
      await axios.delete(`${API_URL}/history/${historyId}`);
      setHistory(history.filter((item) => item.id !== historyId));
    } catch (error) {
      console.error('削除エラー:', error);
      alert('削除に失敗しました');
    }
  };

  return (
    <div className="history-page">
      <header className="page-header">
        <div className="page-header-inner">
          <div className="page-header-left">
            <button type="button" className="nav-ghost" onClick={() => navigate('/')}>
              ← ホーム
            </button>
            <div className="page-brand">
              <div className="page-brand-name">MOMIBO</div>
              <div className="page-brand-sub">会話履歴</div>
            </div>
          </div>
          <a className="nav-primary" href="/auth/dashboard">
            本部ホーム
          </a>
        </div>
      </header>

      <main className="page-shell">
        <section className="page-panel">
          <p className="section-label">History</p>
          <h1 className="page-title">会話履歴</h1>
          <p className="page-lead">過去のやり取りを確認できます。</p>

          {loading ? (
            <div className="state-box">読み込み中…</div>
          ) : history.length === 0 ? (
            <div className="state-box">
              <p>まだ会話履歴がありません</p>
              <button type="button" className="nav-primary" onClick={() => navigate('/chat')}>
                チャットを始める
              </button>
            </div>
          ) : (
            <div className="history-list">
              {history.map((item) => (
                <article key={item.id} className="history-item">
                  <div className="history-meta">
                    <div className="history-meta-left">
                      <span
                        className={
                          item.user_name || item.shop_name
                            ? 'history-author'
                            : 'history-author is-unknown'
                        }
                      >
                        {formatAuthor(item)}
                      </span>
                      <time dateTime={item.created_at}>
                        {new Date(item.created_at).toLocaleString('ja-JP')}
                      </time>
                    </div>
                    <button
                      type="button"
                      className="text-danger"
                      onClick={() => handleDelete(item.id)}
                    >
                      削除
                    </button>
                  </div>
                  <div className="qa-block">
                    <div className="qa-label">質問</div>
                    <div className="qa-body">{item.question}</div>
                  </div>
                  <div className="qa-block is-answer">
                    <div className="qa-label">回答</div>
                    <div className="qa-body">{item.answer}</div>
                  </div>
                </article>
              ))}
            </div>
          )}
        </section>
      </main>
    </div>
  );
}

export default HistoryPage;
